var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { GraphqlMutableStoreBase } from "../GraphqlMutableStoreBase";
import gql from "graphql-tag";
const thermostatSettingsFragment = gql `
  fragment ThermostatSettingsStoreFields on ThermostatSettings {
    id
    settings {
      type
      holdUntil
      daysOfWeek
      atMinutesSinceMidnight
      allowedActions
      setPointHeat
      setPointCool
      setPointCirculateAbove
      setPointCirculateBelow
    }
  }
`;
const thermostatSettingsStoreDocument = gql `
  ${thermostatSettingsFragment}
  query ThermostatSettingsStore {
    getThermostatSettings {
      ...ThermostatSettingsStoreFields
    }
  }
`;
const updateThermostatSettingsStoreDocument = gql `
  ${thermostatSettingsFragment}
  mutation UpdateThermostatSettingsStore($thermostatSettings: ThermostatSettingsUpdateInput!) {
    updateThermostatSettings(thermostatSettings: $thermostatSettings) {
      ...ThermostatSettingsStoreFields
    }
  }
`;
export class ThermostatSettingsStore extends GraphqlMutableStoreBase {
    constructor(authStore, apolloClient) {
        super("ThermostatSettings", authStore, apolloClient, 
        // Mutation
        updateThermostatSettingsStoreDocument, (item) => {
            return { thermostatSettings: item };
        }, 
        // Query
        thermostatSettingsStoreDocument, (queryData) => {
            return queryData.getThermostatSettings;
        }, (thermostatSettings) => {
            // Rehydrate Date types
            return Object.assign(Object.assign({}, thermostatSettings), { settings: thermostatSettings.settings.map(setting => {
                    // Remove GraphQL-injected fields that won't be accepted in a GraphQL mutation
                    // (done automatically for us for top-level types but not for interior arrays)
                    const { __typename } = setting, rest = __rest(setting, ["__typename"]);
                    return Object.assign(Object.assign({}, rest), { holdUntil: setting.holdUntil ? new Date(setting.holdUntil) : undefined });
                }) });
        });
    }
}
//# sourceMappingURL=index.js.map